import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  AdInterface,
  appState,
  AppStateInterface,
  BuildingListInterface,
  FileInterface
} from '../../../../constants/app-state';
import { BehaviorSubject, forkJoin, from, Observable, of, Subscription } from 'rxjs';
import { catchError, concatMap, debounceTime, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotifierService } from 'epgu-lib';
import { ChatsService } from '../../../../services/chats/chats.service';

@Component({
  selector: 'arm-message-building',
  templateUrl: './message-building.component.html',
  styleUrls: ['./message-building.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageBuildingComponent implements OnInit, OnDestroy {

  public scId: number;

  private subscriptions: Subscription = new Subscription();
  private loadingPrivate: boolean;

  constructor(private router: Router,
              private cd: ChangeDetectorRef,
              private notifierService: NotifierService,
              private chatsService: ChatsService) {
  }

  set loading(value: boolean) {
    this.loadingPrivate = value;
    this.cd.detectChanges();
  }

  get loading(): boolean {
    return this.loadingPrivate;
  }

  public nextStep(): void {

    const appStateCopy: AppStateInterface = appState.getValue();

    const multipleChatsMessageStateCopy = appStateCopy.multipleChatsMessage.getValue();

    const buildingIds: string[] = appStateCopy.buildingList.getValue().buildingIds;

    let requestsLength: number;

    this.subscriptions.add(
      this.chatsService.getChatsList({
        buildingIds: buildingIds.join(),
        scId: this.scId,
      })
        .pipe(
          tap(() => this.loading = true),
          debounceTime(500),
          catchError((err) => {
            this.loading = false;

            const description = err.status && err.statusText ? `(${err.status}: ${err.statusText})` : '';
            this.notifierService.error({
              message: `ÐÑÐ¸Ð±ÐºÐ°, Ð½Ðµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº ÑÐ°ÑÐ¾Ð² Ð¿Ð¾ Ð´Ð¾Ð¼Ð°Ð¼ ${description}`,
            });

            return of(null);
          }),
          map((chats: {id: number}[]) => {

            if (Array.isArray(chats) && chats.length) {

              let files: FileInterface[];

              if (appState.getValue().files) {
                files = appState.getValue().files.getValue();
              }

              const requests: any[] = [];

              chats.forEach((chat) => {

                if (multipleChatsMessageStateCopy.text) {

                  console.warn('Hello');
                  
                  requests.push(
                    {
                      chatId: chat.id,
                      body: {
                        scId: this.scId,
                        messageContent: {
                          text: multipleChatsMessageStateCopy.text,
                        },
                        type: 'TEXT',
                        user: {
                          id: -this.scId,
                        },
                      }
                    }
                  );
                }

                if (Array.isArray(files) && files.length) {

                  files.forEach((file) => {

                    console.warn('Hello');
                    requests.push(
                      {
                        chatId: chat.id,
                        body: {
                          scId: this.scId,
                          messageContent: file.value,
                          type: 'FILE',
                          user: {
                            id: -this.scId,
                          },
                        }
                      }
                    );

                  })

                }
              })

              return requests;

            } else {

              return of(null);

            }
          }),
          switchMap((requestBody) => {

            if (Array.isArray(requestBody)) {
              requestsLength = requestBody.length;
              return from(requestBody);
            }

            return of(null);
          }),
          concatMap((item: { chatId: number; body: any }) => {
            if (item) {
              return this.chatsService.sendMessage({chatId: item.chatId, scId: this.scId}, item.body);
            }

            return of(null);
          }),
          catchError((err) => {
            this.loading = false;

            const description = err.status && err.statusText ? `(${err.status}: ${err.statusText})` : '';
            this.notifierService.error({
              message: `ÐÑÐ¸Ð±ÐºÐ°, Ð½Ðµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ ${description}`,
            });

            return of(null);
          }),
        )
        .subscribe((value) => {

          if (!value) { return; }

          --requestsLength;

          if (requestsLength === 0) {
            debugger;

            this.clearMessageFromAppState();

            this.notifierService.success({
              message: `Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð²Ð¾ Ð²ÑÐµ ÑÐ°ÑÑ`,
            });

            const appStateCopy = appState.getValue();

            delete appStateCopy.files;
            delete appStateCopy.multipleChatsMessage;

            appState.next(appStateCopy);

            this.loading = false;

            this.router.navigate(['management-company/chats/list']);
          }
        })
    );
  }

  public clearMessageFromAppState(): void {
    const appStateCopy = appState.getValue();
    delete appStateCopy.multipleChatsMessage;
    appState.next(appStateCopy);
  }

  public ngOnInit(): void {

    this.scId = +localStorage.getItem('SC_ID');

    if (!this.scId) { return; }

    if (!appState.getValue().ad) {
      const appStateCopy = appState.getValue();

      appStateCopy.ad = new BehaviorSubject<AdInterface>({
        heading: '',
      });

      appState.next(appStateCopy);
    }

    if (!appState.getValue().buildingList) {
      const appStateCopy: AppStateInterface = appState.getValue();

      appStateCopy.buildingList = new BehaviorSubject<BuildingListInterface>({
        checkboxOn: false,
        buildingIds: [],
      });

      appState.next(appStateCopy);
    }

    const buildingListStateCopy = appState.getValue().buildingList.getValue();
    buildingListStateCopy.checkboxOn = true;

    appState.getValue().buildingList.next(buildingListStateCopy);

    appState.getValue().progressBar.next({
      show: true,
      value: 100,
    });

  }

  public ngOnDestroy(): void {

    const appStateCopy = appState.getValue();

    const buildingListStateCopy = appStateCopy.buildingList.getValue();

    appStateCopy.buildingList.next({
      checkboxOn: false,
      buildingIds: buildingListStateCopy.buildingIds,
    });

    appState.getValue().progressBar.next({
      show: false,
      value: 0,
    });

    appState.next(appStateCopy);

    this.subscriptions.unsubscribe();
  }

}
